import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'InformesDetalle';

export interface Pais {
  IdPais: string;
  Pais: string;
  Zona: string;
  ContratDetalle: boolean;
}

export class InformesDetalleAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ImportarFichero(data: any): AxiosPromise<any> {
        var formData = new FormData();
        formData.append("files", data.adjuntos[0], data.adjuntos[0].name);
        // formData.append("IdVersion", '33');
        // formData.append("Ejercicio", '2021');
        // formData.append("Mes", '3');
        formData.append("IdTipo", data.idTipoContenido);
        formData.append("tipoImportacion",data.tipoImportacion);
        formData.append("idCentro", data.idCentro);
        formData.append("soloCentro", data.soloCentro);
        return this.cliente.postFile(formData, `/ImportarFichero`);
    }
	
    DescargarPlantilla(data: any): AxiosPromise<Blob> {
        return this.cliente.postDownloadFile(data, `/DescargarPlantilla`);
    }
	
    ListarInformeData(data: any): AxiosPromise<any> {
        return this.cliente.post(data, `/ListarInformeData`);
    }

    setMostrarOcultarCentro(data: any): AxiosPromise<any> {
        return this.cliente.post(data, `/MostrarOcultarCentro`);
    }

    setSubirBajarCentro(data: any): AxiosPromise<any> {
        return this.cliente.post(data, `/SubirBajarCentro`);
    }

    DescargarInforme(data: any): AxiosPromise<Blob> {
        return this.cliente.postDownloadFile(data, `/DescargarInforme`);
    }

    setOtroFormatoCentro(data: any): AxiosPromise<any> {
        return this.cliente.post(data, `/CentroOtroFormato`);
    }
    
    ListarDatosSubidos(data: any): AxiosPromise<any> {
        return this.cliente.post(data, `/ListarDatosSubidos`);
    }

    InformesDetalleUpdate(data: any): AxiosPromise<any> {
        return this.cliente.post(data, `/InformesDetalleUpdate`);
    }

    DescargarDatosPeriodoAbierto(data: any): AxiosPromise<Blob> {
        return this.cliente.postDownloadFile(data, `/DescargarDatosPeriodoAbierto`);
    }

    setLabelBottomGrevol(data: any): AxiosPromise<any> {
        return this.cliente.post(data, `/LabelBottomGrevol`);
    }
}